//
// Module for the Benefit Estimates Index view
//
rs.module("participant/benefit/benefitestimates/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {

            var benefitEstimatesIndex = $.js(jsSelectors.benefitEstimatesIndex);

            var filter = benefitEstimatesIndex.js(jsSelectors.filter);
            var includeMemberGeneratedEstimatesCheckBox = filter.js(jsSelectors.includeMemberGeneratedEstimatesCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            var worksheetPlaceHolder = benefitEstimatesIndex.js(jsSelectors.worksheetPlaceHolder);

            // On checkbox change, reload the grid data via ajax
            includeMemberGeneratedEstimatesCheckBox.change(function () {

                loadingSpinner.show();

                gridModule.update(
                    ajaxUrls.getGridData,
                    { includeMemberGeneratedEstimates: this.checked },
                    lrsGridApi.agGridApi,
                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });

            // Using onjs() because only visible rows in the grid will have their contents rendered. 
            // Selecting by js selector and adding a click handler would only get click handlers hooked up for the visible rows.
            $(document).onjs('click', jsSelectors.gridWorksheetLink, function () {
                var rowWorksheetLink = $(this);
                promptforFasOnWorksheet(rowWorksheetLink.data("benefitestimatekey"));
            });

            // Generate the worksheet control, then manually trigger the prompt for Final Average Salary to be included
            function promptforFasOnWorksheet(benefitEstimateKey) {
                $.get(ajaxUrls.populateFasModal, { benefitEstimateKey: benefitEstimateKey }).done(function (result) {
                    // hide the link we're going to click 
                    // https://stackoverflow.com/questions/22143055/replacing-manipulating-element-in-html-string-using-jquery/22143224#22143224
                    var html = $('<div />', { html: result });

                    // cannot just add display-none class to the 'a' element as generate-worksheet-link has a display that overrides
                    // (and cannot just have worksheetPlaceHolder with display-none as it would also hide the modal)
                    $('a[data-toggle="modal"]', html).wrap('<div class="display-none"></div>');

                    worksheetPlaceHolder.html(html.html());

                    worksheetPlaceHolder.find('a[data-toggle="modal"]').first().click();
                });
            }

            // Using onjs() because only visible rows in the grid will have their contents rendered. 
            // Selecting by js selector and adding a change handler would only get change handlers hooked up for the visible rows.
            $(document).onjs('click', jsSelectors.gridOnMDCheckBox, function () {
                // Get the rows update spinner and show it
                var spinner = $(this).siblingsjs(jsSelectors.gridOnMDSpinner);
                spinner.show();

                var gridOnMDCheckBox = $(this);

                // Make AJAX call to update the estimate
                $.post(
                    ajaxUrls.updateViewEstimateOnline,
                    { benefitEstimateKey: gridOnMDCheckBox.data("benefitestimatekey"), viewEstimateOnline: gridOnMDCheckBox.is(":checked") }
                ).always(function (data) {
                    // Hide row's update spinner
                    spinner.hide();
                });
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);